import { render } from "./SpmHelpIcon.vue?vue&type=template&id=73f041ea&scoped=true"
import script from "./SpmHelpIcon.vue?vue&type=script&lang=ts"
export * from "./SpmHelpIcon.vue?vue&type=script&lang=ts"

import "./SpmHelpIcon.vue?vue&type=style&index=0&id=73f041ea&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-73f041ea"

export default script